import { STARTER_PACKAGE_CALENDLY_URL } from '../constants/billing'

const buildCalendarUrl = () => STARTER_PACKAGE_CALENDLY_URL

export { buildCalendarUrl }
